export const DASHBOARD_URLS = {
  trainer: '/dashboard',
  trainee: '/dashboard'
};

export const PAGE_URLS = {
  ssoLoginUrl: '/onboarding/sso-login',
  myDashboard: '/dashboard',
  createAssessment: '/dashboard/create-assessments',
  myAssignments: '/dashboard/my-assignments',
  trackProgress: '/dashboard/track-progress',
  assignments: 'dashboard/assesments'
};

export const NON_LOGGED_IN_PAGE_URLS = [PAGE_URLS.ssoLoginUrl];

export const SEARCH_PARAMS_KEYS = {
  ssoLoginCode: 'code'
};

export const ONBOARDING_SCREEN = '/onboarding/sso-login';
export const ROLE_ONBOARDING_SCREEN = '/trainer/onboarding/sso-login';
